var PasswordResetEnum = /* @__PURE__ */ ((PasswordResetEnum2) => {
  PasswordResetEnum2["PASSWORD_RESET_FORM"] = "password-reset--form";
  PasswordResetEnum2["PASSWORD_RESET_INPUT_PASSWORD"] = "password-reset--input-password";
  PasswordResetEnum2["PASSWORD_RESET_INPUT_CONFIRM_PASSWORD"] = "password-reset--input-confirm-password";
  PasswordResetEnum2["PASSWORD_RESET_SUBMIT_BUTTON"] = "password-reset--submit-button";
  PasswordResetEnum2["PASSWORD_RESET_EXPIRED_LINK"] = "password-reset--expired-link";
  PasswordResetEnum2["PASSWORD_RESET_REQUEST_NEW_LINK_BUTTON"] = "password-reset--request-new-link-button";
  PasswordResetEnum2["PASSWORD_RESET_NEED_HELP_BUTTON"] = "password-reset--need-help-button";
  return PasswordResetEnum2;
})(PasswordResetEnum || {});
export {
  PasswordResetEnum
};
